export const fetchHumeAccessToken = async (signal?: AbortSignal): Promise<string> => {
  try {
    const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://stronghireai.com';
    
    const response = await fetch(
      `${baseURL}/hume_api/hume_access_token`,
      { signal }
    );


    if (!response.ok) {
      const errorText = await response.text();
      console.error('Response error text:', errorText);
      throw new Error(`Failed to fetch access token: ${response.status} ${response.statusText} - ${errorText}`);
    }

    const data = await response.json();
    return data.access_token;
  } catch (error) {
    console.error('Error fetching Hume access token:', error);
    if (error instanceof TypeError && error.message.includes('fetch')) {
      const baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://stronghireai.com';
      throw new Error(`Cannot connect to backend server. Please ensure your Django server is running on ${baseURL}`);
    }
    throw error;
  }
};
